<template>
    <div class="arbitration-notice" v-show="arbitrationNotice" :style="btm">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <div class="arbitration-notice-title">待申诉仲裁单提醒</div>
                <i class="arbitration-notice-close el-icon-close" @click="onColse"></i>
            </div>
            <div class="arbitration-notice-content">
                <div class="notification-content-top">
                    <p>您好！</p>
                    <el-button type="text" @click="viewAll">查看全部</el-button>
                </div>
                <div class="notification-content-middle">
                    <p>您有<span>{{ totalCount }}笔</span>待申诉仲裁单要处理，请及时处理</p>
                </div>
            </div>
            <div class="arbitration-notice-footer">
                <el-button @click="onColse">已知悉</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import {
    selectDealTodoCountOrder
} from "../../api/notificationWarn.js";

export default {
    data() {
        return {
            arbitrationNotice: false,
            totalCount: 0,
            closeState: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.init();
        }, 3000);
    },
    computed: {
        btm() {
            if (this.closeState) {
                return "bottom: -440px;opacity:0;";
            }
            if (this.totalCount) {
                return "bottom: 5px;opacity:1;";
            }
            return "";
        },
    },
    watch: {},
    methods: {
        init() {
            const value = sessionStorage.getItem("arbitrationNotice");
            if (!value) {
                this.arbitrationNotice = true;
                sessionStorage.setItem("arbitrationNotice", true);
                this.getData();
            } else {
                this.arbitrationNotice = false;
            }
        },
        getData() {
            if (!this.$store.state.supplier.supplierCode) {
                return false;
            }
            const params = {
                departmentSupplierCode: this.$store.state.supplier.supplierCode,
                chanelSource: '3'
            };
            selectDealTodoCountOrder(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalCount = res.data.supplierCodeCount
                }
            });
        },
        onColse() {
            this.closeState = true;
        },
        viewAll() {
            this.$router.push('/outPage/problemListManage?abnormalOrderStatusList=20')
            this.closeState = true;
        }
    }
};
</script>

<style scoped lang="less">
.arbitration-notice {
    position: absolute;
    bottom: -440px;
    right: 80px;
    width: 280px;
    // height: 208px;
    opacity: 0;
    transition: all 0.8s ease;
    z-index: 9999;

    /deep/.el-card__header {
        padding: 10px 18px;
    }

    &-title {
        // height: 30px;
        // line-height: 30px;
        text-align: center;
        // border: 1px solid blue;
    }

    &-close {
        position: absolute;
        right: 5px;
        top: 10px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
            color: #00bcbf;
        }
    }

    &-content {
        font-size: 12px;

        .notification-content-top {
            display: flex;
            height: 26px;
            align-items: center;
            justify-content: space-between;
        }

        .notification-content-middle {
            overflow: auto;

            p {
                margin: 6px 0;
            }

            span {
                color: red;
            }
        }
    }

    &-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 5px 0;
        height: 30px;
    }
}
</style>
